export const ASSETS_SUBMENUS: SubmenuGroup[] = [
  {
    type: 'solutions',
    items: [
      {
        title: 'Infraon ITAM for Manufacturing',
        icon: '/assets/img/logos/features/assets/icon-10.svg',
        url: '/it-asset-management/solutions/infraon-assets-for-manufacturing',
      },
      {
        title: 'Infraon ITAM for Healthcare',
        icon: '/assets/img/logos/features/assets/icon-11.svg',
        url: '/it-asset-management/solutions/infraon-assets-for-healthcare',
      },
      {
        title: 'Infraon ITAM for BFSI',
        icon: '/assets/img/logos/features/assets/icon-12.svg',
        url: '/it-asset-management/solutions/infraon-itam-for-bfsi',
      },
      {
        title: 'Infraon Assets for Education Institution',
        icon: '/assets/img/logos/features/assets/icon-13.svg',
        url: '/it-asset-management/solutions/infraon-assets-for-education-institutions',
      },
      {
        title: 'Infraon ITAM for IT Service',
        icon: '/assets/img/logos/features/assets/icon-14.svg',
        url: '/it-asset-management/solutions/it-service-solutions',
      },
    ],
  },
  {
    type: 'features',
    items: [
      {
        title: 'IT Assets Discovery Software',
        icon: '/assets/img/logos/features/assets/icon-1.svg',
        url: '/it-asset-management/features/it-asset-discovery',
        type: 'core-features',
      },
      {
        title: 'IT Assets Lifecycle Management',
        icon: '/assets/img/logos/features/assets/icon-2.svg',
        url: '/it-asset-management/features/it-asset-lifecycle-management-software',
        type: 'core-features',
      },
      {
        title: 'Software License Management',
        icon: '/assets/img/logos/features/assets/icon-3.svg',
        url: '/it-asset-management/features/software-license-management',
        type: 'core-features',
      },
      {
        title: 'Fixed Asset Management Software',
        icon: '/assets/img/logos/features/assets/icon-4.svg',
        url: '/it-asset-management/features/fixed-asset-management-software',
        type: 'core-features',
      },
      {
        title: 'Barcode Assets Management Software',
        icon: '/assets/img/logos/features/assets/icon-5.svg',
        url: '/it-asset-management/features/barcode-asset-tracking-software',
        type: 'core-features',
      },
      {
        title: 'Spare Parts Management System',
        icon: '/assets/img/logos/features/assets/icon-6.svg',
        url: '/it-asset-management/features/spare-parts-management-system',
        type: 'core-features',
      },
      {
        title: 'IT Helpdesk Software',
        icon: '/assets/img/logos/features/assets/icon-7.svg',
        url: '/it-asset-management/features/it-helpdesk-software',
        type: 'add-ons',
      },
      {
        title: 'Service Desk for MSP',
        icon: '/assets/img/logos/features/assets/icon-8.svg',
        url: '/it-asset-management/features/msp-solution',
        type: 'add-ons',
      },
      {
        title: 'Tickets for Manufacturers',
        icon: '/assets/img/logos/features/assets/icon-9.svg',
        url: '/it-asset-management/features/ticket-management-solutions',
        type: 'add-ons',
      },
    ],
  },
];

export const ITSM_SUBMENUS: SubmenuGroup[] = [
  {
    type: 'solutions',
    items: [
      {
        title: 'ITSM for Manufacturing',
        icon: '/assets/img/logos/features/assets/icon-10.svg',
        url: '/itsm-tool/solutions/infraon-itsm-for-manufacturing',
      },
      {
        title: 'ITSM for Healthcare',
        icon: '/assets/img/logos/features/assets/icon-11.svg',
        url: '/itsm-tool/solutions/infraon-itsm-for-healthcare',
      },
      {
        title: 'ITSM for IT Service',
        icon: '/assets/img/logos/features/assets/icon-12.svg',
        url: '/itsm-tool/solutions/infraon-itsm-for-it-service-solution',
      },
      {
        title: 'ITSM for Education Institution',
        icon: '/assets/img/logos/features/assets/icon-13.svg',
        url: '/itsm-tool/solutions/infraon-itsm-for-education-institutions',
      },
      {
        title: 'IT Service Management for BFSI',
        icon: '/assets/img/logos/features/assets/icon-14.svg',
        url: '/itsm-tool/solutions/infraon-itsm-for-bfsi',
      },
    ],
  },
  {
    type: 'features',
    items: [
      {
        title: 'Agentic Bot',
        icon: '/assets/img/logos/features/itsm/agentic-bot.svg',
        url: '/itsm-tool/features/agentic-bot',
        type: 'core-features',
      },
      {
        title: 'Incident Management',
        icon: '/assets/img/logos/features/itsm/incident.svg',
        url: '/itsm-tool/features/incident-management-software',
        type: 'core-features',
      },
      {
        title: 'Problem Management',
        icon: '/assets/img/logos/features/itsm/problem.svg',
        url: '/itsm-tool/features/problem-management-software',
        type: 'core-features',
      },
      {
        title: 'Change Management',
        icon: '/assets/img/logos/features/itsm/change.svg',
        url: '/itsm-tool/features/change-management-software',
        type: 'core-features',
      },
      {
        title: 'Event Management',
        icon: '/assets/img/logos/features/itsm/event.svg',
        url: '/itsm-tool/features/event-management',
        type: 'core-features',
      },
      {
        title: 'Catalogue Management',
        icon: '/assets/img/logos/features/itsm/catalogue.svg',
        url: '/itsm-tool/features/catalog-management',
        type: 'core-features',
      },
      {
        title: 'Self Service Portal',
        icon: '/assets/img/logos/features/itsm/self-service.svg',
        url: '/itsm-tool/features/self-service-portal',
        type: 'core-features',
      },
      {
        title: 'Workflow Automation',
        icon: '/assets/img/logos/features/itsm/workflow.svg',
        url: '/itsm-tool/features/workflow-automation',
        type: 'add-ons',
      },
      {
        title: 'Service Request Management',
        icon: '/assets/img/logos/features/itsm/service-request.svg',
        url: '/itsm-tool/features/service-request-management',
        type: 'add-ons',
      },
      {
        title: 'SLA Management Solution',
        icon: '/assets/img/logos/features/itsm/sla.svg',
        url: '/itsm-tool/features/sla-management-solution',
        type: 'add-ons',
      },
      {
        title: 'Knowledge Base Management',
        icon: '/assets/img/logos/features/itsm/knowledgebase.svg',
        url: '/itsm-tool/features/knowledge-management-software',
        type: 'add-ons',
      },
    ],
  },
];

export const IMS_SUBMENUS: SubmenuGroup[] = [
  {
    type: 'features',
    items: [
      {
        title: 'IT Event Management',
        icon: '/assets/img/logos/features/itsm/event.svg',
        url: '/itim-ims/features/it-event-management',
        type: 'core-features',
      },
      {
        title: 'Fault Management',
        icon: '/assets/img/logos/features/ims/fault.svg',
        url: '/itim-ims/features/fault-management',
        type: 'core-features',
      },
      {
        title: 'Inventory Management',
        icon: '/assets/img/logos/features/ims/inventory.svg',
        url: '/itim-ims/features/inventory-management',
        type: 'core-features',
      },
      {
        title: 'IT Network Monitoring',
        icon: '/assets/img/logos/features/ims/network.svg',
        url: '/itim-ims/features/it-network-monitoring',
        type: 'core-features',
      },
      {
        title: 'Server Monitoring',
        icon: '/assets/img/logos/features/ims/server.svg',
        url: '/itim-ims/features/server-monitoring',
        type: 'core-features',
      },
      {
        title: 'Cloud Monitoring Solutions',
        icon: '/assets/img/logos/features/ims/cloud.svg',
        url: '/itim-ims/features/cloud-monitoring-solutions',
        type: 'core-features',
      },
      {
        title: 'API Monitoring',
        icon: '/assets/img/logos/features/ims/api.svg',
        url: '/itim-ims/features/api-monitoring',
        type: 'core-features',
      },
      // {
      //   title: 'Incident Management',
      //   icon: '/assets/img/logos/features/ims/icon-8.svg',
      //   url: "/itim-ims/features/incident-management-software",
      //   type: "add-ons"
      // },
      {
        title: 'Application Monitoring',
        icon: '/assets/img/logos/features/ims/application.svg',
        url: '/itim-ims/features/application-monitoring',
        type: 'add-ons',
      },
      {
        title: 'AWS Monitoring',
        icon: '/assets/img/logos/features/ims/aws.svg',
        url: '/itim-ims/features/aws-monitoring-solutions',
        type: 'add-ons',
      },
      {
        title: 'IT SLA Management',
        icon: '/assets/img/logos/features/ims/sla.svg',
        url: '/itim-ims/features/sla-management',
        type: 'add-ons',
      },
      {
        title: 'Network Topology',
        icon: '/assets/img/logos/features/ims/topology.svg',
        url: '/itim-ims/features/network-topology',
        type: 'add-ons',
      },
    ],
  },
];
